import { serialize } from "../../../helpers/helpers";
import { apiRequest, getSluiceUrl } from "../../../apiHelper/apiRequest";

const getDsList = async params => {
  return apiRequest(
    "/school-of-drivers/list?" + serialize(params),
    {
      method: "GET",
    },
    'ptp_client'
  );
}

const addDsList = async params => {
  let add_response = await apiRequest(
    "/school-of-drivers/add",
    {
      method: "POST",
      body: params
    },
    'ptp_client'
  );
  if (typeof (add_response.id) !== 'undefined' && add_response.id)
    return add_response.id;
  else
    return 0;
}

const updateDsList = async params => {
  let add_response = await apiRequest(
    "/school-of-drivers/update",
    {
      method: "PUT",
      body: params
    },
    'ptp_client'
  );
  if (typeof (add_response.id) !== 'undefined' && add_response.id)
    return add_response.id;
  else
    return 0;
}

const deleteDsList = async (id = 0) => {
  let remove_response = await apiRequest(
    `/school-of-drivers/delete/${id}`,
    { method: "DELETE" },
    'ptp_client'
  );
  if (typeof (remove_response.id) !== 'undefined' && remove_response.id)
    return remove_response.id;
  else
    return 0;
}

const getImageUrl = (image_path = '') => {
  if (String(image_path).trim() === '' || image_path.indexOf('http') === 0)
    return image_path;
  return getSluiceUrl('ptp_client') + "/school-of-drivers/files/" + image_path;
}

const driversSchoolApi = {
  getDsList,
  addDsList,
  getImageUrl,
  updateDsList,
  deleteDsList,
};

export default driversSchoolApi;